(() => {
  if (window.__smoofNumberBrandingV221) {
    return;
  }

  window.__smoofNumberBrandingV221 = true;
  window.__smoofNumberBrandingV2 = true;

  const IDS = {
    font:
      '052c068b-772b-4d04-af0d-56214e55cce3',
    enabled:
      '3d6f15f5-b6a7-44d8-8e66-d80fe15b7603',
    text:
      '45b6444d-2b8c-431d-9594-91a6ab688d18',
    style:
      'f0b04c23-daf0-420c-9572-6d05e339241e',
    color:
      '5e5d6fe5-7f13-4891-9903-9ad8949dbb95',
    branding:
      '3f615f11-8440-41a9-af77-fe79452d77f1'
  };

  const STYLES = [
    'Light',
    'Light & Kursiv',
    'Normal',
    'Kursiv',
    'Fett',
    'Fett & Kursiv'
  ];

  const DEFAULT = {
    x: 0.5,
    y: 0.642,
    scale: 1
  };

  const SAFE_RADIUS = 0.3434;

  const SCALE = {
    minimum: 0.1,
    maximum: 12,
    step: 0.1
  };

  const state = {
    x: DEFAULT.x,
    y: DEFAULT.y,
    scale: DEFAULT.scale,
    fitScale: 1,
    fontFamily: ''
  };

  const BRAND_DEFAULT = { x: 0.5, y: 0.804 };
  const brandState = { ...BRAND_DEFAULT, visible: true };

  const requestedFonts = new Set();
  const SELECT_EVENT = 'smoof:editor-select';

  let overlay = null;
  let frame = null;
  let content = null;
  let inlineInput = null;
  let dot = null;
  let numberToggleButton = null;
  let guideX = null;
  let guideY = null;
  let currentStage = null;
  let selectedId = '';
  let activeDrag = null;
  let activeBrandDrag = null;
  let brandStateHydrated = false;
  let editing = false;
  let editStartValue = '';
  let mobileNumberToolbar = null;
  let mobileBrandToolbar = null;
  let renderPending = false;
  let lastNumberToggleAt = 0;

  function isEnglish() {
    return document.documentElement.lang
      .toLowerCase()
      .startsWith('en');
  }

  function t(german, english) {
    return isEnglish()
      ? english
      : german;
  }

  function optionRoot(id) {
    const roots = Array.from(
      document.querySelectorAll(
        `[data-option-id="${id}"]`
      )
    );

    return (
      roots.find(root =>
        root.offsetParent !== null
      ) ||
      roots[0] ||
      null
    );
  }

  function getTextInput() {
    return optionRoot(IDS.text)
      ?.querySelector(
        'input[type="text"], textarea'
      ) || null;
  }

  function getNumberEnabledInput() {
    return (
      optionRoot(IDS.enabled)
        ?.querySelector(
          'input[type="checkbox"]'
        ) || null
    );
  }

  function isNumberEnabled() {
    return Boolean(
      getNumberEnabledInput()?.checked
    );
  }

  function setNumberEnabled(enabled) {
    const input =
      getNumberEnabledInput();

    if (
      !input ||
      input.disabled ||
      input.checked === enabled
    ) {
      scheduleRender();
      return;
    }

    /*
     * Der echte Klick lässt Easify seine
     * Bedingungen, Pflichtfelder und
     * Bestelldaten selbst aktualisieren.
     */
    input.click();
    window.setTimeout(
      scheduleRender,
      0
    );
  }

  window.SmoofNumberVisibilityTools =
    Object.freeze({
      isVisible() {
        return isNumberEnabled();
      },

      setVisible(visible) {
        const next = Boolean(visible);
        setNumberEnabled(next);
        return next;
      },

      toggleVisibility() {
        const next = !isNumberEnabled();
        setNumberEnabled(next);
        return next;
      }
    });

  function activateNumberToggle(
    event,
    enabled
  ) {
    event.preventDefault();
    event.stopPropagation();

    const now = Date.now();

    /*
     * iOS Safari erzeugt nach touchend
     * teilweise noch einen zweiten click.
     */
    if (
      now - lastNumberToggleAt < 600
    ) {
      return;
    }

    lastNumberToggleAt = now;
    setNumberEnabled(enabled);
  }

  function wireNumberToggleAction(
    button,
    enabled
  ) {
    button.addEventListener(
      'pointerdown',
      event => {
        event.stopPropagation();
      }
    );

    button.addEventListener(
      'touchend',
      event => {
        activateNumberToggle(
          event,
          enabled
        );
      },
      { passive: false }
    );

    button.addEventListener(
      'click',
      event => {
        activateNumberToggle(
          event,
          enabled
        );
      }
    );
  }

  function getColor(id, fallback = '#000000') {
    return (
      optionRoot(id)
        ?.querySelector(
          'input[type="color"]'
        )
        ?.value ||
      fallback
    );
  }

  function getSelectedValue(
    id,
    fallback = ''
  ) {
    const root = optionRoot(id);

    return (
      root?.querySelector('select')
        ?.value ||
      root?.querySelector(
        'input[type="hidden"]'
      )?.value ||
      root?.querySelector(
        'button[aria-haspopup="listbox"]'
      )?.innerText.trim() ||
      fallback
    );
  }

  function setNativeValue(
    control,
    value,
    commit = false
  ) {
    if (!control) return;

    const prototype =
      control instanceof HTMLSelectElement
        ? HTMLSelectElement.prototype
        : control instanceof HTMLTextAreaElement
          ? HTMLTextAreaElement.prototype
          : HTMLInputElement.prototype;

    const descriptor =
      Object.getOwnPropertyDescriptor(
        prototype,
        'value'
      );

    if (descriptor?.set) {
      descriptor.set.call(
        control,
        value
      );
    } else {
      control.value = value;
    }

    control.dispatchEvent(
      new Event(
        'input',
        {
          bubbles: true
        }
      )
    );

    if (commit) {
      control.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );
    }
  }

  function setColor(
    id,
    value,
    commit = false
  ) {
    setNativeValue(
      optionRoot(id)
        ?.querySelector(
          'input[type="color"]'
        ),
      value,
      commit
    );
  }

  function normalizeStyle(value) {
    const normalized =
      String(value || '')
        .toLowerCase();

    const light =
      normalized.includes('light') ||
      normalized.includes('leicht');

    const bold =
      normalized.includes('bold') ||
      normalized.includes('fett');

    const italic =
      normalized.includes('italic') ||
      normalized.includes('kursiv');

    if (light && italic) {
      return 'Light & Kursiv';
    }

    if (light) return 'Light';

    if (bold && italic) {
      return 'Fett & Kursiv';
    }

    if (bold) return 'Fett';
    if (italic) return 'Kursiv';

    return 'Normal';
  }

  function fontStyle(value) {
    const normalized =
      normalizeStyle(value);

    return {
      weight:
        normalized.startsWith('Light')
          ? '300'
          : normalized.startsWith('Fett')
            ? '700'
            : '400',
      style:
        normalized.includes('Kursiv')
          ? 'italic'
          : 'normal'
    };
  }

  function setStyle(value) {
    const root = optionRoot(IDS.style);
    const select =
      root?.querySelector('select');

    const control =
      select ||
      root?.querySelector(
        'input[type="hidden"]'
      );

    if (!control) return;

    let nextValue = value;

    if (select) {
      const match =
        Array.from(select.options)
          .find(option =>
            normalizeStyle(
              option.textContent ||
              option.value
            ) === value
          );

      if (match) {
        nextValue = match.value;
      }
    }

    setNativeValue(
      control,
      nextValue,
      true
    );
  }

  function cleanFontFamily(value) {
    return String(value || '')
      .replace(/["']/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 100);
  }

  function getGlobalFont() {
    return cleanFontFamily(
      getSelectedValue(
        IDS.font,
        'Roboto'
      )
    ) || 'Roboto';
  }

  function getFont() {
    return cleanFontFamily(state.fontFamily) || getGlobalFont();
  }

  function ensureFont(
    family,
    weight,
    style
  ) {
    const cleanFamily =
      String(family || '')
        .replace(/["']/g, '')
        .trim();

    if (!cleanFamily) return;

    if (
      window.SmoofCustomFontRegistry
        ?.isCustomFamily?.(cleanFamily)
    ) {
      window.SmoofCustomFontRegistry
        .ensureLoaded(cleanFamily)
        .then(scheduleRender)
        .catch(() => {});
      return;
    }

    const italic =
      style === 'italic' ? 1 : 0;

    const key =
      `${cleanFamily}|${italic}|${weight}`;

    if (requestedFonts.has(key)) return;
    requestedFonts.add(key);

    const encodedFamily =
      encodeURIComponent(cleanFamily)
        .replace(/%20/g, '+');

    const link =
      document.createElement('link');

    link.rel = 'stylesheet';
    link.href =
      `https://fonts.googleapis.com/css2?family=${encodedFamily}:ital,wght@${italic},${weight}&display=swap`;

    link.addEventListener(
      'load',
      scheduleRender,
      {
        once: true
      }
    );

    document.head.appendChild(link);
  }

  function clamp(value, minimum, maximum) {
    return Math.min(
      maximum,
      Math.max(minimum, value)
    );
  }

  function constrainState() {
    const stageRect =
      currentStage
        ?.getBoundingClientRect();

    const contentRect =
      content?.getBoundingClientRect();

    const halfHeight =
      (
        stageRect?.height &&
        contentRect?.height
      )
        ? contentRect.height /
          stageRect.height /
          2
        : 0.009;
    const halfWidth =
      (
        stageRect?.width &&
        contentRect?.width
      )
        ? contentRect.width /
          stageRect.width /
          2
        : 0.05;

    const next = window.SmoofSpatialConstraints?.constrainRect({
      x: state.x,
      y: state.y,
      halfWidth,
      halfHeight,
      radius: SAFE_RADIUS,
      qrPadding: 0.001
    });
    if (!next) return;
    state.x = next.x;
    state.y = next.y;
  }

  function constrainBrandState() {
    const half = 0.014;
    const next = window.SmoofSpatialConstraints?.constrainRect({
      x: brandState.x,
      y: brandState.y,
      halfWidth: half,
      halfHeight: half,
      radius: SAFE_RADIUS,
      qrPadding: 0.001
    });
    if (!next) return;
    brandState.x = next.x;
    brandState.y = next.y;
  }

  function updateBrandPosition() {
    if (!dot) return;
    constrainBrandState();
    dot.style.left = `${brandState.x * 100}%`;
    dot.style.top = `${brandState.y * 100}%`;
  }

  function finishBrandDrag(event) {
    const drag = activeBrandDrag;
    if (!drag || drag.pointerId !== event.pointerId) return;
    activeBrandDrag = null;
    dot?.releasePointerCapture?.(event.pointerId);
    hideSnapGuides();
    syncOrderProperties();
    window.SmoofDesignRenderer?.scheduleRender?.();
    event.preventDefault();
    event.stopPropagation();
  }

  function attachBrandInteractions() {
    if (!dot || dot.dataset.smoofBrandDragReady === 'true') return;
    dot.dataset.smoofBrandDragReady = 'true';
    dot.addEventListener('pointerdown', event => {
      if (event.button !== 0) return;
      selectItem('branding-dot');
      activeBrandDrag = {
        pointerId: event.pointerId,
        clientX: event.clientX,
        clientY: event.clientY,
        x: brandState.x,
        y: brandState.y
      };
      dot.setPointerCapture?.(event.pointerId);
      event.preventDefault();
      event.stopPropagation();
    });
    dot.addEventListener('pointermove', event => {
      const drag = activeBrandDrag;
      if (!drag || drag.pointerId !== event.pointerId || !currentStage) return;
      const rect = currentStage.getBoundingClientRect();
      brandState.x = drag.x + (event.clientX - drag.clientX) / rect.width;
      brandState.y = drag.y + (event.clientY - drag.clientY) / rect.height;
      const sharedGuides = window.SmoofAlignmentGuides;
      const guideAtX = sharedGuides
        ? sharedGuides.nearestX(brandState.x, 0.012)
        : Math.abs(brandState.x - 0.5) <= 0.012
          ? 0.5
          : null;
      const guideAtY = sharedGuides?.nearestY?.(brandState.y, 0.012) ??
        (Math.abs(brandState.y - BRAND_DEFAULT.y) <= 0.012 ? BRAND_DEFAULT.y : null);
      if (Number.isFinite(guideAtX)) brandState.x = guideAtX;
      if (Number.isFinite(guideAtY)) brandState.y = guideAtY;
      constrainBrandState();
      if (sharedGuides) {
        if (guideX) guideX.style.display = 'none';
        if (Number.isFinite(guideAtX)) sharedGuides.showX(guideAtX);
        else sharedGuides.hideX();
        if (Number.isFinite(guideAtY)) sharedGuides.showY?.(guideAtY);
        else sharedGuides.hideY?.();
      } else if (guideX) {
        guideX.style.left = `${Number(guideAtX ?? 0.5) * 100}%`;
        guideX.style.display = Number.isFinite(guideAtX) ? 'block' : 'none';
      }
      if (guideY) {
        guideY.style.display = Number.isFinite(guideAtY) ? 'block' : 'none';
        guideY.style.top = `${Number(guideAtY ?? BRAND_DEFAULT.y) * 100}%`;
      }
      updateBrandPosition();
      syncOrderProperties();
      event.preventDefault();
      event.stopPropagation();
    });
    dot.addEventListener('pointerup', finishBrandDrag);
    dot.addEventListener('pointercancel', finishBrandDrag);
  }

  function applySnapping() {
    const sharedGuides = window.SmoofAlignmentGuides;
    const guideAtX = sharedGuides
      ? sharedGuides.nearestX(state.x, 0.012)
      : Math.abs(state.x - DEFAULT.x) <= 0.012
        ? DEFAULT.x
        : null;
    const snapX = Number.isFinite(guideAtX);

    const guideAtY = sharedGuides?.nearestY?.(state.y, 0.012) ??
      (Math.abs(state.y - DEFAULT.y) <= 0.012 ? DEFAULT.y : null);
    const snapY = Number.isFinite(guideAtY);

    if (snapX) state.x = guideAtX;
    if (snapY) state.y = guideAtY;

    if (sharedGuides) {
      if (guideX) guideX.style.display = 'none';
      if (snapX) sharedGuides.showX(guideAtX);
      else sharedGuides.hideX();
      if (snapY) sharedGuides.showY?.(guideAtY);
      else sharedGuides.hideY?.();
    } else if (guideX) {
      guideX.style.left = `${Number(guideAtX ?? DEFAULT.x) * 100}%`;
      guideX.style.display = snapX ? 'block' : 'none';
    }

    if (guideY) {
      guideY.style.display =
        snapY ? 'block' : 'none';

      guideY.style.top =
        `${Number(guideAtY ?? DEFAULT.y) * 100}%`;
    }
  }

  function hideSnapGuides() {
    if (guideX) guideX.style.display = 'none';
    if (guideY) guideY.style.display = 'none';
    window.SmoofAlignmentGuides?.hideAll?.();
  }

  function setQrProtectionActive(
    active
  ) {
    window.dispatchEvent(
      new CustomEvent(
        'smoof:qr-protection-active',
        {
          detail: {
            active: Boolean(active)
          }
        }
      )
    );
  }

  function selectItem(id) {
    window.dispatchEvent(
      new CustomEvent(
        SELECT_EVENT,
        {
          detail: {
            id: String(id || '')
          }
        }
      )
    );
  }

  function applySelection(id) {
    const nextId = String(id || '');

    if (
      editing &&
      nextId !== 'table-number'
    ) {
      finishEdit(true);
    }

    selectedId = nextId;

    if (frame) {
      frame.dataset.active =
        String(
          selectedId ===
            'table-number'
        );
    }

    if (dot) {
      dot.dataset.active =
        String(
          selectedId ===
            'branding-dot'
        );
    }

    if (overlay) {
      overlay.style.zIndex =
        (
          selectedId ===
            'table-number' ||
          selectedId ===
            'branding-dot'
        )
          ? '82'
          : '72';
    }

    updateMobileToolbars();
  }

  function createButton(
    type,
    label,
    ariaLabel
  ) {
    const button =
      document.createElement('button');

    button.type = 'button';
    button.textContent = label;
    button.dataset
      .smoofNumberControlButton =
      type;

    button.setAttribute(
      'aria-label',
      ariaLabel
    );

    return button;
  }

  function createStyleControl() {
    const wrapper =
      document.createElement('label');

    wrapper.dataset
      .smoofNumberStyleControl =
      'true';

    const label =
      document.createElement('span');

    label.textContent = 'Aa';

    const select =
      document.createElement('select');

    select.dataset
      .smoofNumberStyleSelect =
      'true';

    select.setAttribute(
      'aria-label',
      t(
        'Schriftschnitt der Tisch- oder Zimmernummer',
        'Font style of the table or room number'
      )
    );

    STYLES.forEach(value => {
      const option =
        document.createElement('option');

      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });

    wrapper.append(
      label,
      select
    );

    return wrapper;
  }

  function createNumberColorControl() {
    const wrapper =
      document.createElement('label');

    wrapper.dataset
      .smoofNumberColorControl =
      'true';

    const input =
      document.createElement('input');

    input.type = 'color';
    input.dataset
      .smoofNumberColorInput =
      'true';

    input.setAttribute(
      'aria-label',
      t(
        'Farbe der Tisch- oder Zimmernummer',
        'Colour of the table or room number'
      )
    );

    wrapper.appendChild(input);
    return wrapper;
  }

  function createNumberToggleButton() {
    const button =
      document.createElement('button');

    button.type = 'button';
    button.dataset.smoofNumberToggle =
      'true';

    button.textContent = t(
      '+ Nummer',
      '+ Number'
    );

    button.setAttribute(
      'aria-label',
      t(
        'Tisch- oder Zimmernummer hinzufügen',
        'Add table or room number'
      )
    );

    wireNumberToggleAction(
      button,
      true
    );

    return button;
  }

  function createNumberVisibilityButton() {
    const button = createButton(
      'visibility',
      '',
      t(
        'Tisch- oder Zimmernummer ausblenden',
        'Hide table or room number'
      )
    );

    button.innerHTML = `
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path
          d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"
        ></path>
        <circle
          cx="12"
          cy="12"
          r="2.6"
        ></circle>
        <path d="M4 4 20 20"></path>
      </svg>
    `;

    /*
     * Derselbe semantische Selektor wie bei den drei Textzeilen:
     * So übernimmt Liquid 14 exakt dieselbe Größe und Darstellung.
     */
    button.dataset.smoofTextControlButton =
      'visibility';

    button.dataset.visible = 'true';

    return button;
  }

  function createBrandColorControl() {
    const wrapper =
      document.createElement('label');

    wrapper.dataset
      .smoofBrandColorControl =
      'true';

    const input =
      document.createElement('input');

    input.type = 'color';
    input.dataset
      .smoofBrandColorInput =
      'true';

    input.setAttribute(
      'aria-label',
      t(
        'Farbe des kleinen Kreises',
        'Colour of the small circle'
      )
    );

    wrapper.appendChild(input);
    return wrapper;
  }

  function wireNumberControls(controls) {
    const style =
      controls.querySelector(
        '[data-smoof-number-style-select]'
      );

    const color =
      controls.querySelector(
        '[data-smoof-number-color-input]'
      );

    const minus =
      controls.querySelector(
        '[data-smoof-number-control-button="minus"]'
      );

    const plus =
      controls.querySelector(
        '[data-smoof-number-control-button="plus"]'
      );

    const reset =
      controls.querySelector(
        '[data-smoof-number-control-button="reset"]'
      );

    const visibility =
      controls.querySelector(
        '[data-smoof-number-control-button="visibility"]'
      );

    controls.addEventListener(
      'pointerdown',
      event => {
        event.stopPropagation();
      }
    );

    style.addEventListener(
      'change',
      event => {
        event.stopPropagation();
        setStyle(style.value);
        selectItem('table-number');
        scheduleRender();
      }
    );

    color.addEventListener(
      'input',
      event => {
        event.stopPropagation();
        setColor(
          IDS.color,
          color.value
        );
        selectItem('table-number');
        scheduleRender();
      }
    );

    color.addEventListener(
      'change',
      event => {
        event.stopPropagation();
        setColor(
          IDS.color,
          color.value,
          true
        );
      }
    );

    minus.addEventListener(
      'click',
      event => {
        event.preventDefault();
        event.stopPropagation();
        changeScale(-SCALE.step);
      }
    );

    plus.addEventListener(
      'click',
      event => {
        event.preventDefault();
        event.stopPropagation();
        changeScale(SCALE.step);
      }
    );

    reset.addEventListener(
      'click',
      event => {
        event.preventDefault();
        event.stopPropagation();
        resetNumber();
      }
    );

    if (visibility) {
      wireNumberToggleAction(
        visibility,
        false
      );
    }
  }

  function createNumberControls() {
    const controls =
      document.createElement('div');

    controls.dataset
      .smoofNumberControls =
      'true';

    controls.dataset.smoofEditorItem =
      'table-number';

    controls.append(
      createStyleControl(),
      createNumberColorControl(),
      createButton(
        'minus',
        '−',
        t(
          'Nummer verkleinern',
          'Reduce number size'
        )
      ),
      createButton(
        'plus',
        '+',
        t(
          'Nummer vergrößern',
          'Increase number size'
        )
      ),
      createButton(
        'reset',
        '↺',
        t(
          'Nummer zurücksetzen',
          'Reset number'
        )
      ),
      createNumberVisibilityButton()
    );

    wireNumberControls(controls);
    return controls;
  }

  function wireBrandControl(controls) {
    const input =
      controls.querySelector(
        '[data-smoof-brand-color-input]'
      );

    controls.addEventListener(
      'pointerdown',
      event => {
        event.stopPropagation();
        selectItem('branding-dot');
      }
    );

    input.addEventListener(
      'input',
      event => {
        event.stopPropagation();
        setColor(
          IDS.branding,
          input.value
        );
        scheduleRender();
      }
    );

    input.addEventListener(
      'change',
      event => {
        event.stopPropagation();
        setColor(
          IDS.branding,
          input.value,
          true
        );
      }
    );
  }

  function createBrandControls() {
    const controls =
      document.createElement('div');

    controls.dataset
      .smoofBrandControls =
      'true';

    controls.dataset.smoofEditorItem =
      'branding-dot';

    controls.appendChild(
      createBrandColorControl()
    );

    wireBrandControl(controls);
    return controls;
  }

  function createMobileNumberToolbar() {
    const toolbar =
      document.createElement('div');

    toolbar.dataset
      .smoofNumberMobileToolbar =
      'true';

    toolbar.dataset.smoofEditorItem =
      'table-number';

    toolbar.hidden = true;

    toolbar.append(
      createStyleControl(),
      createNumberColorControl(),
      createButton(
        'minus',
        '−',
        t(
          'Nummer verkleinern',
          'Reduce number size'
        )
      ),
      createButton(
        'plus',
        '+',
        t(
          'Nummer vergrößern',
          'Increase number size'
        )
      ),
      createButton(
        'reset',
        '↺',
        t(
          'Nummer zurücksetzen',
          'Reset number'
        )
      ),
      createNumberVisibilityButton()
    );

    wireNumberControls(toolbar);
    document.body.appendChild(toolbar);
    return toolbar;
  }

  function createMobileBrandToolbar() {
    const toolbar =
      document.createElement('div');

    toolbar.dataset
      .smoofBrandMobileToolbar =
      'true';

    toolbar.dataset.smoofEditorItem =
      'branding-dot';

    toolbar.hidden = true;

    toolbar.appendChild(
      createBrandColorControl()
    );

    wireBrandControl(toolbar);
    document.body.appendChild(toolbar);
    return toolbar;
  }

  function isMobile() {
    return window.matchMedia(
      '(max-width: 749px)'
    ).matches;
  }

  function updateControlValues(root) {
    if (!root) return;

    const style =
      root.querySelector(
        '[data-smoof-number-style-select]'
      );

    const color =
      root.querySelector(
        '[data-smoof-number-color-input]'
      );

    if (
      style &&
      document.activeElement !== style
    ) {
      style.value =
        normalizeStyle(
          getSelectedValue(
            IDS.style,
            'Normal'
          )
        );
    }

    if (
      color &&
      document.activeElement !== color
    ) {
      color.value =
        getColor(IDS.color);
    }
  }

  function updateBrandControlValue(root) {
    const input =
      root?.querySelector(
        '[data-smoof-brand-color-input]'
      );

    if (
      input &&
      document.activeElement !== input
    ) {
      input.value =
        getColor(
          IDS.branding,
          '#ffffff'
        );
    }
  }

  function updateMobileToolbars() {
    if (!isMobile()) {
      if (mobileNumberToolbar) {
        mobileNumberToolbar.hidden = true;
      }

      if (mobileBrandToolbar) {
        mobileBrandToolbar.hidden = true;
      }

      return;
    }

    if (selectedId === 'table-number') {
      mobileNumberToolbar =
        mobileNumberToolbar?.isConnected
          ? mobileNumberToolbar
          : createMobileNumberToolbar();

      mobileNumberToolbar.hidden = false;
      updateControlValues(
        mobileNumberToolbar
      );
    } else if (mobileNumberToolbar) {
      mobileNumberToolbar.hidden = true;
    }

    if (selectedId === 'branding-dot') {
      mobileBrandToolbar =
        mobileBrandToolbar?.isConnected
          ? mobileBrandToolbar
          : createMobileBrandToolbar();

      mobileBrandToolbar.hidden = false;
      updateBrandControlValue(
        mobileBrandToolbar
      );
    } else if (mobileBrandToolbar) {
      mobileBrandToolbar.hidden = true;
    }
  }

  function changeScale(amount) {
    state.scale = clamp(
      state.scale + amount,
      SCALE.minimum,
      SCALE.maximum
    );

    selectItem('table-number');
    render();
  }

  function resetNumber() {
    state.x = DEFAULT.x;
    state.y = DEFAULT.y;
    state.scale = DEFAULT.scale;
    state.fitScale = 1;
    hideSnapGuides();
    selectItem('table-number');
    render();
  }

  function beginEdit() {
    const easifyInput =
      getTextInput();

    if (
      !frame ||
      !inlineInput ||
      !easifyInput
    ) {
      return;
    }

    editing = true;
    editStartValue =
      easifyInput.value || '';

    frame.dataset.editing = 'true';
    inlineInput.value = editStartValue;
    inlineInput.focus();

    const end =
      inlineInput.value.length;

    inlineInput.setSelectionRange(
      end,
      end
    );
  }

  function finishEdit(
    commit = true,
    restore = false
  ) {
    if (!editing) return;

    const value =
      restore
        ? editStartValue
        : inlineInput?.value || '';

    editing = false;
    editStartValue = '';

    if (frame) {
      frame.dataset.editing = 'false';
    }

    setNativeValue(
      getTextInput(),
      value,
      commit
    );

    render();
  }

  function finishDrag(event) {
    if (!activeDrag) return;

    const drag = activeDrag;
    activeDrag = null;

    if (
      frame?.hasPointerCapture?.(
        drag.pointerId
      )
    ) {
      frame.releasePointerCapture(
        drag.pointerId
      );
    }

    frame.style.cursor = 'grab';
    hideSnapGuides();
    setQrProtectionActive(false);
    syncOrderProperties();

    if (
      event?.type === 'pointerup' &&
      !drag.moved
    ) {
      beginEdit();
    }
  }

  function attachFrameInteractions() {
    frame.addEventListener(
      'pointerdown',
      event => {
        if (
          event.target.closest(
            [
              '[data-smoof-number-controls]',
              '[data-smoof-number-inline-input]'
            ].join(',')
          )
        ) {
          return;
        }

        if (
          selectedId !==
            'table-number'
        ) {
          selectItem('table-number');
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        activeDrag = {
          pointerId: event.pointerId,
          startPointerX: event.clientX,
          startPointerY: event.clientY,
          startX: state.x,
          startY: state.y,
          moved: false
        };

        frame.setPointerCapture(
          event.pointerId
        );

        frame.style.cursor = 'grabbing';
        event.preventDefault();
      }
    );

    frame.addEventListener(
      'pointermove',
      event => {
        if (
          !activeDrag ||
          activeDrag.pointerId !==
            event.pointerId
        ) {
          return;
        }

        const stageRect =
          currentStage
            .getBoundingClientRect();

        const distance =
          Math.hypot(
            event.clientX -
              activeDrag.startPointerX,
            event.clientY -
              activeDrag.startPointerY
          );

        if (
          distance > 3 &&
          !activeDrag.moved
        ) {
          activeDrag.moved = true;
          setQrProtectionActive(true);
        }

        state.x =
          activeDrag.startX +
          (
            event.clientX -
            activeDrag.startPointerX
          ) / stageRect.width;

        state.y =
          activeDrag.startY +
          (
            event.clientY -
            activeDrag.startPointerY
          ) / stageRect.height;

        constrainState();
        applySnapping();
        updateFramePosition();
        syncOrderProperties();
        event.preventDefault();
      }
    );

    frame.addEventListener(
      'pointerup',
      finishDrag
    );

    frame.addEventListener(
      'pointercancel',
      finishDrag
    );

    frame.addEventListener(
      'lostpointercapture',
      finishDrag
    );

    inlineInput.addEventListener(
      'pointerdown',
      event => {
        event.stopPropagation();
      }
    );

    inlineInput.addEventListener(
      'input',
      () => {
        setNativeValue(
          getTextInput(),
          inlineInput.value
        );
        scheduleRender();
      }
    );

    inlineInput.addEventListener(
      'keydown',
      event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          finishEdit(true);
        } else if (
          event.key === 'Escape'
        ) {
          event.preventDefault();
          finishEdit(
            true,
            true
          );
        }
      }
    );

    inlineInput.addEventListener(
      'blur',
      () => {
        if (editing) {
          finishEdit(true);
        }
      }
    );
  }

  function removeOverlay() {
    setQrProtectionActive(false);
    overlay?.remove();
    mobileNumberToolbar?.remove();
    mobileBrandToolbar?.remove();

    overlay = null;
    frame = null;
    content = null;
    inlineInput = null;
    dot = null;
    numberToggleButton = null;
    guideX = null;
    guideY = null;
    currentStage = null;
    activeDrag = null;
    editing = false;
    mobileNumberToolbar = null;
    mobileBrandToolbar = null;
  }

  function ensureOverlay(stage) {
    if (
      overlay?.isConnected &&
      currentStage === stage
    ) {
      return;
    }

    removeOverlay();

    overlay =
      document.createElement('div');

    overlay.dataset
      .smoofNumberBrandOverlay =
      'true';

    Object.assign(
      overlay.style,
      {
        position: 'absolute',
        display: 'block',
        inset: '0',
        zIndex: '72',
        overflow: 'hidden',
        pointerEvents: 'none'
      }
    );

    guideX =
      document.createElement('div');

    guideX.dataset
      .smoofNumberSnapGuide =
      'x';

    guideY =
      document.createElement('div');

    guideY.dataset
      .smoofNumberSnapGuide =
      'y';

    numberToggleButton =
      createNumberToggleButton();

    frame =
      document.createElement('div');

    frame.dataset.smoofNumberFrame =
      'true';

    frame.dataset.smoofEditorItem =
      'table-number';

    frame.dataset.active = 'false';
    frame.dataset.editing = 'false';

    content =
      document.createElement('span');

    content.dataset
      .smoofNumberContent =
      'true';

    inlineInput =
      document.createElement('input');

    inlineInput.type = 'text';
    inlineInput.inputMode = 'text';
    inlineInput.enterKeyHint = 'done';
    inlineInput.autocomplete = 'off';
    inlineInput.spellcheck = true;
    inlineInput.dataset
      .smoofNumberInlineInput =
      'true';

    inlineInput.setAttribute(
      'aria-label',
      t(
        'Tisch- oder Zimmernummer direkt bearbeiten',
        'Edit table or room number directly'
      )
    );

    frame.append(
      content,
      inlineInput,
      createNumberControls()
    );

    dot =
      document.createElement('button');

    dot.type = 'button';
    dot.dataset.smoofBrandDot =
      'true';

    dot.dataset.smoofEditorItem =
      'branding-dot';

    dot.dataset.active = 'false';

    dot.setAttribute(
      'aria-label',
      t(
        'Farbe des kleinen Kreises auswählen',
        'Select the colour of the small circle'
      )
    );

    dot.addEventListener(
      'pointerdown',
      event => {
        event.preventDefault();
        event.stopPropagation();
        selectItem('branding-dot');
      }
    );

    overlay.append(
      guideX,
      guideY,
      numberToggleButton,
      frame,
      dot,
      createBrandControls()
    );

    stage.appendChild(overlay);
    currentStage = stage;
    attachFrameInteractions();
    applySelection(selectedId);
  }

  function updateFramePosition() {
    if (!frame) return;

    frame.style.left =
      `${state.x * 100}%`;

    frame.style.top =
      `${state.y * 100}%`;
  }

  function updateNumberAppearance(
    stageWidth
  ) {
    const easifyInput =
      getTextInput();

    const value =
      easifyInput?.value.trim() || '';

    const placeholder =
      isEnglish()
        ? 'TABLE 56'
        : 'TISCH 56';

    const selectedStyle =
      getSelectedValue(
        IDS.style,
        'Normal'
      );

    const family = getFont();

    const customFont =
      window.SmoofCustomFontRegistry
        ?.isCustomFamily?.(family);

    const style = customFont
      ? fontStyle('Normal')
      : fontStyle(selectedStyle);

    ensureFont(
      family,
      style.weight,
      style.style
    );

    content.textContent =
      value || placeholder;

    content.dataset.placeholder =
      String(!value);

    content.style.fontFamily =
      `"${family}", "Roboto", sans-serif`;

    content.style.fontWeight =
      style.weight;

    content.style.fontStyle =
      style.style;

    content.style.fontSynthesis =
      customFont
        ? 'none'
        : 'weight style';

    content.style.letterSpacing =
      '0.08em';

    content.style.color =
      getColor(IDS.color);

    const baseSize =
      stageWidth *
      0.018 *
      state.scale;

    content.style.fontSize =
      `${baseSize}px`;

    state.fitScale = 1;

    const maximumWidth =
      stageWidth * 0.26;

    const naturalWidth =
      content.getBoundingClientRect()
        .width;

    if (
      naturalWidth > maximumWidth &&
      naturalWidth > 0
    ) {
      state.fitScale =
        maximumWidth /
        naturalWidth;

      content.style.fontSize =
        `${
          baseSize *
          state.fitScale
        }px`;
    }

    if (
      document.activeElement !==
        inlineInput
    ) {
      inlineInput.value =
        easifyInput?.value || '';
    }

    inlineInput.placeholder =
      t(
        'z. B. Tisch 56',
        'e.g. Table 56'
      );

    if (
      easifyInput?.maxLength > 0
    ) {
      inlineInput.maxLength =
        easifyInput.maxLength;
    }

    inlineInput.style.fontFamily =
      content.style.fontFamily;

    inlineInput.style.fontWeight =
      content.style.fontWeight;

    inlineInput.style.fontStyle =
      content.style.fontStyle;

    inlineInput.style.letterSpacing =
      content.style.letterSpacing;

    inlineInput.style.color =
      content.style.color;

    inlineInput.style.fontSize =
      content.style.fontSize;

    inlineInput.style.width =
      `${
        Math.max(
          88,
          Math.min(
            maximumWidth,
            naturalWidth + 20
          )
        )
      }px`;

    updateControlValues(
      frame.querySelector(
        '[data-smoof-number-controls]'
      )
    );
  }

  function getProductForm() {
    return Array.from(
      document.querySelectorAll(
        'form[action*="/cart/add"]'
      )
    ).find(form =>
      form.querySelector(
        'button[type="submit"]'
      )
    );
  }

  function setProperty(
    form,
    name,
    value
  ) {
    let input = Array.from(
      form.querySelectorAll('input')
    ).find(element =>
      element.name === name
    );

    if (!input) {
      input =
        document.createElement('input');

      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
  }

  function syncOrderProperties() {
    const form = getProductForm();
    if (!form) return;

    setProperty(
      form,
      'properties[_SMOOF Nummer aktiviert]',
      isNumberEnabled()
        ? 'Ja'
        : 'Nein'
    );

    setProperty(
      form,
      'properties[_SMOOF Nummer X]',
      state.x.toFixed(4)
    );

    setProperty(
      form,
      'properties[_SMOOF Nummer Y]',
      state.y.toFixed(4)
    );

    setProperty(
      form,
      'properties[_SMOOF Nummer Skalierung]',
      state.scale.toFixed(4)
    );

    setProperty(
      form,
      'properties[_SMOOF Nummer Auto-Fit]',
      state.fitScale.toFixed(4)
    );

    setProperty(
      form,
      'properties[_SMOOF Nummer Schriftart]',
      getFont()
    );

    setProperty(
      form,
      'properties[_SMOOF Nummer-Editor Version]',
      'number-branding-v2'
    );

    setProperty(
      form,
      'properties[_SMOOF Branding sichtbar]',
      brandState.visible ? 'Ja' : 'Nein'
    );
  }

  function render() {
    const marker =
      document.querySelector(
        '#smoof-preview-extension'
      );

    const stage =
      document.querySelector(
        '.po-livePreview-stage .konvajs-content'
      );

    const brandOption =
      optionRoot(IDS.branding);

    if (
      !marker ||
      !stage ||
      !brandOption
    ) {
      removeOverlay();
      return;
    }

    ensureOverlay(stage);

    if (!brandStateHydrated) {
      const form = getProductForm();
      const read = (name, fallback) => {
        const input = Array.from(form?.querySelectorAll('input') || [])
          .find(element => element.name === name);
        const value = Number.parseFloat(input?.value);
        return Number.isFinite(value) ? value : fallback;
      };
      const visibleInput = Array.from(form?.querySelectorAll('input') || [])
        .find(element => element.name === 'properties[_SMOOF Branding sichtbar]');
      brandState.x = BRAND_DEFAULT.x;
      brandState.y = BRAND_DEFAULT.y;
      brandState.visible = !visibleInput || visibleInput.value !== 'Nein';
      brandStateHydrated = true;
    }

    updateBrandPosition();

    const numberEnabledInput =
      getNumberEnabledInput();

    const numberEnabled = Boolean(
      numberEnabledInput?.checked
    );

    numberToggleButton.hidden =
      !numberEnabledInput ||
      numberEnabled;

    numberToggleButton.setAttribute(
      'aria-pressed',
      String(numberEnabled)
    );

    overlay
      .querySelectorAll(
        '[data-smoof-number-control-button="visibility"]'
      )
      .forEach(button => {
        button.dataset.visible =
          String(numberEnabled);

        button.setAttribute(
          'aria-label',
          numberEnabled
            ? t(
                'Tisch- oder Zimmernummer ausblenden',
                'Hide table or room number'
              )
            : t(
                'Tisch- oder Zimmernummer einblenden',
                'Show table or room number'
              )
        );
      });

    dot.style.backgroundColor =
      getColor(
        IDS.branding,
        '#ffffff'
      );
    dot.hidden = !brandState.visible;

    updateBrandControlValue(
      overlay.querySelector(
        '[data-smoof-brand-controls]'
      )
    );

    const numberVisible =
      numberEnabled &&
      Boolean(getTextInput()) &&
      Boolean(optionRoot(IDS.style)) &&
      Boolean(optionRoot(IDS.color));

    frame.hidden = !numberVisible;

    if (
      !numberVisible &&
      selectedId === 'table-number'
    ) {
      selectItem('');
    }

    if (numberVisible) {
      const stageWidth =
        stage.getBoundingClientRect()
          .width;

      if (stageWidth) {
        updateNumberAppearance(
          stageWidth
        );
        constrainState();
        updateFramePosition();
      }
    }

    updateMobileToolbars();
    syncOrderProperties();

    marker.dataset
      .smoofNumberBrandingStatus =
      'active';

    marker.dataset
      .smoofNumberBrandingVersion =
      'number-branding-v2-21-custom-font-registry';
  }

  function scheduleRender() {
    if (renderPending) return;

    renderPending = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        renderPending = false;
        render();
      });
    });
  }

  window.SmoofNumberHistory = {
    getState() {
      return {
        x: state.x,
        y: state.y,
        scale: state.scale,
        fitScale: state.fitScale,
        fontFamily: getFont()
      };
    },

    getFont() {
      return getFont();
    },

    freezeFont() {
      if (!cleanFontFamily(state.fontFamily)) state.fontFamily = getGlobalFont();
      return state.fontFamily;
    },

    setFont(value) {
      const family = cleanFontFamily(value);
      if (!family || !/^[a-z0-9 ._-]+$/i.test(family)) return false;
      state.fontFamily = family;
      if (window.SmoofCustomFontRegistry?.isCustomFamily?.(family)) {
        setStyle('Normal');
      }
      render();
      syncOrderProperties();
      return family;
    },

    applyState(next) {
      if (!next || typeof next !== 'object') return false;

      ['x', 'y', 'scale', 'fitScale'].forEach(key => {
        const value = Number(next[key]);
        if (Number.isFinite(value)) state[key] = value;
      });
      const family = cleanFontFamily(next.fontFamily);
      if (family && /^[a-z0-9 ._-]+$/i.test(family)) state.fontFamily = family;

      activeDrag = null;
      hideSnapGuides();
      setQrProtectionActive(false);
      render();
      syncOrderProperties();
      return true;
    }
  };

  window.SmoofBrandTools = Object.freeze({
    getState: () => ({ ...brandState }),
    getHistoryState: () => ({ ...brandState }),
    applyHistoryState(next) {
      if (!next || typeof next !== 'object') return false;
      ['x', 'y'].forEach(key => {
        const value = Number(next[key]);
        if (Number.isFinite(value)) brandState[key] = value;
      });
      if (typeof next.visible === 'boolean') brandState.visible = next.visible;
      activeBrandDrag = null;
      hideSnapGuides();
      render();
      syncOrderProperties();
      window.SmoofDesignRenderer?.scheduleRender?.();
      window.dispatchEvent(new CustomEvent('smoof:branding-visibility-changed', {
        detail: { visible: brandState.visible }
      }));
      return true;
    },
    isVisible: () => brandState.visible,
    toggleVisibility() {
      brandState.visible = !brandState.visible;
      if (dot) dot.hidden = !brandState.visible;
      syncOrderProperties();
      window.SmoofDesignRenderer?.scheduleRender?.();
      window.dispatchEvent(new CustomEvent('smoof:branding-visibility-changed', {
        detail: { visible: brandState.visible }
      }));
      return brandState.visible;
    }
  });

  window.addEventListener(
    SELECT_EVENT,
    event => {
      applySelection(
        event.detail?.id
      );
    }
  );

  window.addEventListener(
    'smoof:editor-reset-all',
    () => {
      state.x = DEFAULT.x;
      state.y = DEFAULT.y;
      state.scale = DEFAULT.scale;
      state.fitScale = 1;
      state.fontFamily = '';
      brandState.x = BRAND_DEFAULT.x;
      brandState.y = BRAND_DEFAULT.y;
      brandState.visible = true;
      activeDrag = null;
      activeBrandDrag = null;
      hideSnapGuides();
      render();
      syncOrderProperties();
    }
  );

  window.addEventListener(
    'smoof:editor-reset-layout',
    () => {
      state.x = DEFAULT.x;
      state.y = DEFAULT.y;
      state.scale = DEFAULT.scale;
      state.fitScale = 1;
      brandState.x = BRAND_DEFAULT.x;
      brandState.y = BRAND_DEFAULT.y;
      activeDrag = null;
      activeBrandDrag = null;
      hideSnapGuides();
      render();
      syncOrderProperties();
    }
  );

  window.addEventListener(
    'resize',
    scheduleRender
  );

  window.addEventListener(
    'smoof:qr-geometry-change',
    scheduleRender
  );

  document.addEventListener(
    'input',
    scheduleRender,
    true
  );

  document.addEventListener(
    'change',
    scheduleRender,
    true
  );

  new MutationObserver(scheduleRender)
    .observe(document.body, {
      childList: true,
      subtree: true
    });

  window.setInterval(
    scheduleRender,
    500
  );

  scheduleRender();
})();
